// freshシリーズページロジック
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  initProductGallery();
  initProductTabSwitch();
  initInitialTabFromUrl();
  initQuantitySelector();
  initSetSelector();
  initSetGallerySync();
  initVariantSelector();
});


// URLパラメータの商品IDに応じて、該当タブを初期選択する。
// initProductTabSwitchに依存しているので実行順注意
function initInitialTabFromUrl() {
  var urlParams = new URLSearchParams(window.location.search),
    productId = urlParams.get('productid');

  if (!productId) {
    return;
  }

  var targetTabBtn = document.querySelector('.js-product__tabbtn[data-productid="' + productId + '"]');

  if (targetTabBtn) {
    targetTabBtn.click();
  }
}

// 商品ギャラリー メイン+サムネイル連動スライダー
var setGallerySplide = null;

function initProductGallery() {
  var galleryEls = document.querySelectorAll('.p-product__gallery');

  if (galleryEls.length === 0) {
    return;
  }

  Array.from(galleryEls).forEach(function (galleryEl) {
    var mainEl = galleryEl.querySelector('.p-product__gallery__main'),
      thumbEl = galleryEl.querySelector('.p-product__gallery__splide');

    if (!mainEl || !thumbEl) {
      return;
    }

    var slides = mainEl.querySelectorAll('.splide__slide');

    if (slides.length <= 1) {
      return;
    }

    var prevEl = thumbEl.querySelector('.splide__prev'),
      nextEl = thumbEl.querySelector('.splide__next');

    var mainSplide = new Splide(mainEl, {
      type: 'fade',
      rewind: true,
      perPage: 1,
      pagination: false,
      arrows: false
    });

    var thumbSplide = new Splide(thumbEl, {
      type: 'slide',
      perPage: 4,
      gap: 8,
      pagination: false,
      arrows: false,
      isNavigation: true
    });

    function updateArrowsState() {
      if (thumbSplide.index === 0) {
        prevEl.classList.add('is-disabled');
      } else {
        prevEl.classList.remove('is-disabled');
      }

      if (thumbSplide.index >= thumbSplide.length - 1) {
        nextEl.classList.add('is-disabled');
      } else {
        nextEl.classList.remove('is-disabled');
      }
    }

    if (prevEl) {
      prevEl.addEventListener('click', function () {
        thumbSplide.go('<');
      });
    }

    if (nextEl) {
      nextEl.addEventListener('click', function () {
        thumbSplide.go('>');
      });
    }

    thumbSplide.on('mounted move', updateArrowsState);

    mainSplide.sync(thumbSplide);
    mainSplide.mount();
    thumbSplide.mount();

    galleryEl.splideMainInstance = mainSplide;

    if (galleryEl.getAttribute('data-product') === 'set') {
      setGallerySplide = mainSplide;
    }
  });
}

// 商品切り替え(タブ・ギャラリー連動)
function initProductTabSwitch() {
  var tabButtons = document.querySelectorAll('.js-product__tabbtn'),
    galleriesWrapper = document.querySelector('.js-galleries'),
    tabsWrapper = document.querySelector('.js-product__tabs');

  if (tabButtons.length === 0 || !galleriesWrapper || !tabsWrapper) {
    return;
  }

  var galleries = galleriesWrapper.querySelectorAll('.js-gallery'),
    tabs = tabsWrapper.querySelectorAll('.js-product__tab');

  Array.from(tabButtons).forEach(function (btn, index) {
    btn.addEventListener('click', function () {
      Array.from(tabButtons).forEach(function (button) {
        button.classList.remove('is-active');
      });
      Array.from(galleries).forEach(function (gallery) {
        gallery.classList.remove('is-active');
      });
      Array.from(tabs).forEach(function (tab) {
        tab.classList.remove('is-active');
      });

      btn.classList.add('is-active');

      if (galleries[index]) {
        galleries[index].classList.add('is-active');
      }
      if (tabs[index]) {
        tabs[index].classList.add('is-active');
        resetConfirmCheckbox(tabs[index]);
      }
    });
  });

  function resetConfirmCheckbox(tabEl) {
    var confirmCheckbox = tabEl.querySelector('.js-confirm');

    if (confirmCheckbox && confirmCheckbox.checked) {
      confirmCheckbox.checked = false;
      confirmCheckbox.dispatchEvent(new Event('change'));
    }
  }
}

// セット商品選択時の処理
function initSetSelector() {
  var setRadios = document.querySelectorAll('.js-set__btn input[name="set"]');

  if (setRadios.length === 0) {
    return;
  }

  var form = setRadios[0].closest('form'),
    hiddenIdInput = form.querySelector('.js-set-variant-id'),
    productNameEl = form.querySelector('.js-set-productname'),
    priceEl = form.querySelector('.js-set-price'),
    detailListEl = form.querySelector('.js-set-detaillist'),
    cartBtn = form.querySelector('.js-set-cartbtn'),
    cartBtnText = form.querySelector('.js-set-cartbtn-text'),
    cartIcon = form.querySelector('.js-set-carticon'),
    reserveTextEl = form.querySelector('.js-set-reservetext'),
    explanationEl = form.querySelector('.js-set-explanation');

  Array.from(setRadios).forEach(function (radio) {
    radio.addEventListener('change', function () {
      var label = radio.closest('.js-set__btn'),
        isSoldout = label.getAttribute('data-soldout') === 'true',
        isPreorder = label.getAttribute('data-preorder') === 'true';

      Array.from(document.querySelectorAll('.js-set__btn')).forEach(function (l) {
        l.classList.remove('is-active');
      });
      label.classList.add('is-active');

      hiddenIdInput.value = radio.value;
      productNameEl.textContent = radio.getAttribute('data-productname');
      priceEl.textContent = formatPrice(radio.getAttribute('data-price'));

      updateSetDetailList(label);
      updateCartButtonState(cartBtn, cartIcon, cartBtnText, isSoldout, isPreorder, false);
      updateReserveText(reserveTextEl, isPreorder, label.getAttribute('data-deliverydate'));
    });
  });

  function updateSetDetailList(label) {
    var capacity = label.getAttribute('data-capacity'),
      size = label.getAttribute('data-size'),
      purpose = label.getAttribute('data-purpose'),
      delivery = label.getAttribute('data-delivery');

    var capacityEl = detailListEl.querySelector('.js-detail-capacity'),
      sizeEl = detailListEl.querySelector('.js-detail-size'),
      purposeEl = detailListEl.querySelector('.js-detail-purpose');

    toggleDetailItem(capacityEl, capacity);
    toggleDetailItem(sizeEl, size);
    toggleDetailItem(purposeEl, purpose);

    if (capacity || size || purpose) {
      detailListEl.classList.remove('is-empty');
    } else {
      detailListEl.classList.add('is-empty');
    }

    updateExplanation(explanationEl, delivery);
  }
}

// セット商品選択時スライド移動処理
function initSetGallerySync() {
  var setBtns = document.querySelectorAll('.js-set__btn');

  if (setBtns.length === 0) {
    return;
  }

  Array.from(setBtns).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!setGallerySplide) {
        return;
      }

      var productId = btn.getAttribute('data-productid'),
        targetSlide = document.querySelector(
          '.p-product__gallery[data-product="set"] .p-product__gallery__main [data-setproductid="' + productId + '"]'
        );

      if (!targetSlide) {
        return;
      }

      var slideIndex = Array.from(targetSlide.parentElement.children).indexOf(targetSlide);

      setGallerySplide.go(slideIndex);
    });
  });
}

// 個別商品バリアント選択時の処理
function initVariantSelector() {
  var variantTabs = document.querySelectorAll('.p-product__info__variants');

  if (variantTabs.length === 0) {
    return;
  }

  Array.from(variantTabs).forEach(function (variantsEl) {
    var tabEl = variantsEl.closest('.js-product__tab'),
      form = variantsEl.closest('form'),
      hiddenIdInput = form.querySelector('.js-variant-id'),
      productNameEl = form.querySelector('.js-variant-productname'),
      priceEl = form.querySelector('.js-variant-price'),
      cartBtn = form.querySelector('.js-variant-cartbtn'),
      cartBtnText = form.querySelector('.js-variant-cartbtn-text'),
      cartIcon = form.querySelector('.js-variant-carticon'),
      reserveTextEl = form.querySelector('.js-variant-reservetext'),
      confirmBox = form.querySelector('.js-variant-confirmbox'),
      confirmCheckbox = form.querySelector('.js-confirm'),
      radios = variantsEl.querySelectorAll('.js-variant__btn input[type="radio"]'),
      productId = tabEl.getAttribute('data-product'),
      hasNeedpumpTag = tabEl.getAttribute('data-needpump') === 'true',
      galleryEl = document.querySelector('.p-product__gallery[data-product="' + productId + '"]');

    Array.from(radios).forEach(function (radio) {
      radio.addEventListener('change', function () {
        var label = radio.closest('.js-variant__btn'),
          optionValueId = label.getAttribute('data-optionvalueid'),
          isSoldout = label.getAttribute('data-soldout') === 'true',
          isPreorder = label.getAttribute('data-preorder') === 'true';

        Array.from(variantsEl.querySelectorAll('.js-variant__btn')).forEach(function (l) {
          l.classList.remove('is-active');
        });
        label.classList.add('is-active');

        hiddenIdInput.value = label.getAttribute('data-variantid');
        productNameEl.innerHTML = label.getAttribute('data-productname');
        priceEl.textContent = formatPrice(label.getAttribute('data-price'));

        var showConfirm = hasNeedpumpTag && isSoldout === false;

        if (confirmBox) {
          if (showConfirm) {
            confirmBox.style.display = '';
            if (confirmCheckbox) {
              confirmCheckbox.checked = false;
            }
          } else {
            confirmBox.style.display = 'none';
          }
        }

        updateCartButtonState(cartBtn, cartIcon, cartBtnText, isSoldout, isPreorder, showConfirm);

        if (isPreorder) {
          reserveTextEl.classList.remove('is-empty');
        } else {
          reserveTextEl.classList.add('is-empty');
        }

        if (galleryEl && galleryEl.splideMainInstance) {
          var targetSlide = galleryEl.querySelector('.p-product__gallery__main [data-optionvalueid="' + optionValueId + '"]');

          if (targetSlide) {
            var slideIndex = Array.from(targetSlide.parentElement.children).indexOf(targetSlide);
            galleryEl.splideMainInstance.go(slideIndex);
          }
        }
      });
    });

    if (confirmCheckbox && cartBtn) {
      confirmCheckbox.addEventListener('change', function () {
        if (confirmCheckbox.checked) {
          cartBtn.removeAttribute('disabled');
        } else {
          cartBtn.setAttribute('disabled', 'disabled');
        }
      });
    }
  });
}

// 数量選択処理
function initQuantitySelector() {
  var quantitySelectors = document.querySelectorAll('.p-product__info__quantityselector');

  Array.from(quantitySelectors).forEach(function (selector) {
    var minusBtn = selector.querySelector('.js-quantity-minus'),
      plusBtn = selector.querySelector('.js-quantity-plus'),
      input = selector.querySelector('.js-quantity-input');

    minusBtn.addEventListener('click', function () {
      var currentValue = parseInt(input.value, 10) || 1,
        minValue = parseInt(input.getAttribute('min'), 10) || 1;

      if (currentValue > minValue) {
        input.value = currentValue - 1;
        input.dispatchEvent(new Event('change'));
      }
    });

    plusBtn.addEventListener('click', function () {
      var currentValue = parseInt(input.value, 10) || 1;

      input.value = currentValue + 1;
      input.dispatchEvent(new Event('change'));
    });

    input.addEventListener('change', function () {
      var currentValue = parseInt(input.value, 10),
        minValue = parseInt(input.getAttribute('min'), 10) || 1;

      if (isNaN(currentValue) || currentValue < minValue) {
        input.value = minValue;
      }
    });
  });
}

// 価格を整形して表示用の文字列にする(共通処理)
function formatPrice(cents) {
  return Number(cents / 100).toLocaleString();
}

// カートボタンの状態(disabled、アイコン、テキスト)を更新する(共通処理)
function updateCartButtonState(cartBtn, cartIcon, cartBtnText, isSoldout, isPreorder, disableForConfirm) {
  if (isSoldout) {
    cartBtn.setAttribute('disabled', 'disabled');
    cartIcon.style.display = 'none';
    cartBtnText.textContent = '在庫切れ';
    return;
  }

  cartIcon.style.display = '';

  if (isPreorder) {
    cartBtnText.textContent = '予約購入する';
  } else {
    cartBtnText.textContent = 'カートに入れる';
  }

  if (disableForConfirm) {
    cartBtn.setAttribute('disabled', 'disabled');
  } else {
    cartBtn.removeAttribute('disabled');
  }
}

// 予約商品テキストの表示・非表示、日付の反映(共通処理)
function updateReserveText(reserveTextEl, isPreorder, deliveryDate) {
  if (!isPreorder) {
    reserveTextEl.classList.add('is-empty');
    return;
  }

  reserveTextEl.classList.remove('is-empty');

  if (deliveryDate) {
    reserveTextEl.innerHTML = 'こちらの商品は予約商品です。<span class="js-set-reservedate">' + deliveryDate + '</span>以降、順次発送予定です。';
  } else {
    reserveTextEl.innerHTML = 'こちらの商品は予約商品です。発送まで通常よりお時間をいただきます。';
  }
}

// 容量・サイズ・用途の表示切り替え(共通処理)
function toggleDetailItem(itemEl, value) {
  if (!itemEl) {
    return;
  }

  if (value) {
    itemEl.style.display = '';
    itemEl.querySelector('.js-detail-value').innerHTML = value.replace(/\n/g, '<br>');
  } else {
    itemEl.style.display = 'none';
  }
}

// カート下の配送説明文の表示切り替え(共通処理)
function updateExplanation(explanationEl, value) {
  if (!explanationEl) {
    return;
  }

  if (value) {
    explanationEl.innerHTML = value.replace(/\n/g, '<br>');
    explanationEl.classList.remove('is-empty');
  } else {
    explanationEl.innerHTML = '';
    explanationEl.classList.add('is-empty');
  }
}